import React from 'react'
import styled from 'styled-components'
import { SIZES } from '../styles/theme'
import { useObject } from 'react-firebase-hooks/database'
import { NoticeDb } from '../firebaseConfig'

const Wrapper = styled.div`
  min-height: 30px;
  marquee {
    ${SIZES.noticeBar}
    position: fixed;
    left: 0;
    right: 0;
    background: #222;
    z-index: 300;
    color: #fff;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 1px;
    padding: 2px 0;
    span {
      margin: 0 0.8em;
    }
  }
`

export default function NoticeBar() {
  const [snapshot, loading, error] = useObject(NoticeDb)

  if (loading || error) {
    return <></>
  }

  return (
    <Wrapper>
      <marquee scrollamount={5}>
        <span>{snapshot.val()}</span>
      </marquee>
    </Wrapper>
  )
}
